import { config } from './lib';

export * from './lib';
export default config;
